import type {
  CreateAreaRequest,
  ListAreasResponse,
  RoomAreaListItem,
  UpdateAreaRequest,
} from '@kreart/shared';
import { api } from '@/lib/api';

const base = (projectId: string, roomId: string) => `/projects/${projectId}/rooms/${roomId}/areas`;

export const areasApi = {
  list: (projectId: string, roomId: string) => api.get<ListAreasResponse>(base(projectId, roomId)),
  create: (projectId: string, roomId: string, body: CreateAreaRequest) =>
    api.post<RoomAreaListItem>(base(projectId, roomId), body),
  update: (projectId: string, roomId: string, id: string, body: UpdateAreaRequest) =>
    api.patch<RoomAreaListItem>(`${base(projectId, roomId)}/${id}`, body),
  remove: (projectId: string, roomId: string, id: string) =>
    api.delete<void>(`${base(projectId, roomId)}/${id}`),
};
